import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useDebounce, usePrevious } from 'react-use'

import { DEFAULT_DEBOUNCE_MS } from './constants'
import { SetStateHandler } from './types'

/**
 * debounce search hooks
 *
 * @return
 * [
 *   debounceSearch,
 *   setDebounceSearch,
 *   cancelDebounceSearch,
 *   search,
 *   setSearch,
 *   maybePrevious
 * ]
 */
export function useSearch(
  debounceMs = DEFAULT_DEBOUNCE_MS
): [string, SetStateHandler, () => void, string, SetStateHandler, string?] {
  const [searchParams, setSearchParams] = useSearchParams()
  const [search, setSearch] = useState(searchParams.get('search') || '')
  const [debounceSearch, setDebounceSearch] = useState(searchParams.get('search') || '')
  const previous = usePrevious(debounceSearch)

  const [, cancelDebounceSearch] = useDebounce(
    () => {
      setDebounceSearch(search)
    },
    debounceMs,
    [search]
  )

  useEffect(() => {
    if (debounceSearch) {
      searchParams.set('search', debounceSearch)
      /*if (searchParams.get('search')) {
        searchParams.set('search', debounceSearch)
      } else {
        searchParams.append('search', debounceSearch)
      }*/
      setSearchParams(searchParams)
    } else {
      if (searchParams.get('search')) {
        searchParams.delete('search')
        setSearchParams(searchParams)
      }
    }
  }, [debounceSearch, searchParams, setSearchParams])

  return [debounceSearch, setDebounceSearch, cancelDebounceSearch, search, setSearch, previous]
}
